import React, { useMemo } from 'react';
import { Rarity } from '@dcl/schemas';
import { CatalogCard as AssetCardUi } from 'decentraland-ui/dist/components/CatalogCard/CatalogCard';
import { formatWeiToAssetCardEther, getCatalogCardInformation } from './utils';
import { t } from '../../modules/translation/utils';
export const AssetCard = (props) => {
    const { asset, assetFilters } = props;
    const i18n = {
        listing: t('@dapps.asset_card.listing'),
        listings: t('@dapps.asset_card.listings'),
        available_for_mint: t('@dapps.asset_card.available_for_mint'),
        available_listings_in_range: t('@dapps.asset_card.available_listings_in_range'),
        cheapest_listing: t('@dapps.asset_card.cheapest_listing'),
        not_for_sale: t('@dapps.asset_card.not_for_sale'),
        owner: t('@dapps.asset_card.owner'),
        owners: t('@dapps.asset_card.owners'),
        cheapest_option: t('@dapps.asset_card.cheapest_option'),
        cheapest_option_range: t('@dapps.asset_card.cheapest_option_range'),
        most_expensive: t('@dapps.asset_card.most_expensive'),
        most_expensive_range: t('@dapps.asset_card.most_expensive_range'),
        also_minting: t('@dapps.asset_card.also_minting')
    };
    const catalogItemInformation = useMemo(() => {
        return getCatalogCardInformation(asset, i18n, assetFilters);
    }, [asset]);
    const isAvailableForMint = asset.isOnSale && asset.available > 0;
    const notForSale = !isAvailableForMint && !asset.minListingPrice;
    const price = useMemo(() => {
        return catalogItemInformation.price?.includes('-')
            ? `${formatWeiToAssetCardEther(catalogItemInformation.price.split(' - ')[0])} - ${formatWeiToAssetCardEther(catalogItemInformation.price.split(' - ')[1])}`
            : catalogItemInformation.price
                ? formatWeiToAssetCardEther(catalogItemInformation.price)
                : undefined;
    }, [catalogItemInformation.price]);
    const propsCard = {
        asset: {
            id: asset.id,
            url: asset.url,
            name: asset.name,
            rarity: asset.rarity,
            network: asset.network,
            creator: asset.creator
        },
        action: catalogItemInformation.action,
        actionIcon: catalogItemInformation.actionIcon,
        imagensrc: asset.thumbnail,
        extraInformation: catalogItemInformation.extraInformation,
        notForSale: notForSale,
        price: price,
        owners: `${asset.owners} ${asset.owners === 1 ? i18n.owner : i18n.owners}`,
        i18n: {
            rarities: {
                [Rarity.COMMON]: t('@dapps.rarities.common'),
                [Rarity.UNCOMMON]: t('@dapps.rarities.uncommon'),
                [Rarity.EXOTIC]: t('@dapps.rarities.exotic'),
                [Rarity.RARE]: t('@dapps.rarities.rare'),
                [Rarity.EPIC]: t('@dapps.rarities.epic'),
                [Rarity.LEGENDARY]: t('@dapps.rarities.legendary'),
                [Rarity.MYTHIC]: t('@dapps.rarities.mythic'),
                [Rarity.UNIQUE]: t('@dapps.rarities.unique')
            },
            rarities_description: {
                [Rarity.COMMON]: t('@dapps.rarities_description.common'),
                [Rarity.UNCOMMON]: t('@dapps.rarities_description.uncommon'),
                [Rarity.EXOTIC]: t('@dapps.rarities_description.exotic'),
                [Rarity.RARE]: t('@dapps.rarities_description.rare'),
                [Rarity.EPIC]: t('@dapps.rarities_description.epic'),
                [Rarity.LEGENDARY]: t('@dapps.rarities_description.legendary'),
                [Rarity.MYTHIC]: t('@dapps.rarities_description.mythic'),
                [Rarity.UNIQUE]: t('@dapps.rarities_description.unique')
            }
        }
    };
    return React.createElement(AssetCardUi, { ...propsCard });
};
//# sourceMappingURL=AssetCard.js.map